(() => {
  if (window.__shippingToSelectorInit) return;
  window.__shippingToSelectorInit = true;

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-shipping-to-drawer-trigger]')) {
      window.dispatchEvent(new Event('fluco:modal:shippingToDrawer:open'));
    }
  });

  // The drawer opens via the native dialog top layer (data-fluco-dialog-backdrop="true"
  // -> showModal(), see assets/theme.js), which always paints above any regular
  // z-index-based overlay — including third-party popups like Klaviyo's fullscreen
  // modal (z-index: 90000 but NOT a native <dialog>). If a Klaviyo modal opens while
  // our drawer is still open, it renders hidden behind it. Closing our drawer as soon
  // as a Klaviyo modal appears lets it render normally on top instead.
  //
  // IMPORTANT: do NOT use a MutationObserver with attributes:true/subtree:true on
  // document.documentElement for this — an earlier version did, and it froze the
  // whole page. Watching every style/class change on the entire document fires
  // constantly (header/carousel animations, lazy-loaded images, Klaviyo's own
  // frequent re-renders, ...), and calling getComputedStyle (forces a layout
  // recalculation) inside that firehose is enough to lock up the main thread.
  // Polling on a bounded interval, only while our own drawer is open, is cheap
  // and safe: the check is a couple of querySelector calls, capped to a handful
  // of times a second, and only runs at all while the drawer is on screen.
  let klaviyoCheckIntervalId = null;

  const closeDrawerIfKlaviyoVisible = () => {
    const klaviyoModal = document.querySelector('[data-kl-scroll-locking-modal="true"]');
    if (!klaviyoModal || getComputedStyle(klaviyoModal).display === 'none') return;

    window.dispatchEvent(new Event('fluco:modal:shippingToDrawer:close'));
  };

  window.addEventListener('fluco:modal:shippingToDrawer:open', () => {
    clearInterval(klaviyoCheckIntervalId);
    klaviyoCheckIntervalId = setInterval(closeDrawerIfKlaviyoVisible, 400);
  });

  window.addEventListener('fluco:modal:shippingToDrawer:close', () => {
    clearInterval(klaviyoCheckIntervalId);
  });
})();
